import { createHikoSession, toHikoShopDomain } from "@repo/shopify/utils/hiko";

import { SHOPIFY_DOMAIN } from "@const/urls";

import { useCustomerStore } from "@store/customer";

const JP_SHOP_DOMAIN = toHikoShopDomain(SHOPIFY_DOMAIN.jp);

/**
 * 클릭 시점에 어떤 방식(provider)으로 로그인을 시도했는지 sessionStorage에 잠깐 기록해두는 키.
 * 위젯이 곧바로 풀 리다이렉트로 페이지를 이동시키므로, 리다이렉트-백 후(hikoAuthSync.ts의
 * acceptHikoLogin)에 이 값을 읽어 store에 영구 반영한다(SocialLoginCaa.tsx가 기록).
 * Shopify customer에 provider가 태깅되지 않는 상태(신버전 앱)라 프론트에서 이렇게라도 잡아두는 것 —
 * 이 브라우저에서 로그인을 "시도한" 시점 기준이라 다른 기기에서의 로그인은 알 수 없는 best-effort 값.
 */
export const HIKO_LOGIN_PROVIDER_KEY = "hikoLoginProvider";

/** jp 스토어의 hiko 위젯 세션 (공통 로직은 @repo/shopify/utils/hiko) */
const hikoSession = createHikoSession({
  shopDomain: JP_SHOP_DOMAIN,
  setToken: (caaToken) => {
    useCustomerStore.getState().loginCaa(caaToken);
  },
  clearToken: () => {
    useCustomerStore.getState().logout();
  },
});

export const { refreshCaaToken: refreshHikoCaaToken, logout: hikoLogout, getSessionToken: getHikoSessionToken } = hikoSession;

export default hikoSession;
